import './styles.scss'
import React from 'react'
import { YOUR_NEWS_GUIDELINES } from '../../Utils'

const GuidelinesButton = ({ onOpenGuidelines, isActive = false }) => (
  <button type="button" className={`guidelines-button${isActive ? ' guidelines-button--active' : ''}`} onClick={onOpenGuidelines} data-testid="your-news-guidelines-btn">
    <img src="https://coffeeweb.s3.ap-south-1.amazonaws.com/your_news.png" alt="User Guide" className="guidelines-button__icon" />
    <span className="guidelines-button__label">ABOUT YOUR NEWS</span>
  </button>
)

export default GuidelinesButton
export { YOUR_NEWS_GUIDELINES }
